import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  TimePicker,
  DatePicker,
  Button,
  message,
} from "antd";
import axios from "axios";

function AttendanceForm() {
  const [form] = Form.useForm(); // 使用antd的Form Hooks
  const { Option } = Select;
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios
      .get("/api/getDepartments") // 替换为你的 API 端点
      .then((response) => {
        setDepartments(response.data); // 假设响应数据是部门列表
      })
      .catch((error) => {
        console.error("获取部门数据失败:", error);
      });
  }, []);

  // 处理部门选择变化
  const handleDepartmentChange = (selectedDepartment) => {
    // 根据选择的部门更新names
    // 例如，这里我们可以假设每个部门有不同的员工名单
    axios
      .post(`/api/getUserNames/${selectedDepartment}`) // 替换为你的 API 端点
      .then((response) => {
        setUsers(response.data); // 假设响应数据是部门列表
      })
      .catch((error) => {
        console.error("获取数据失败:", error);
      });
  };

  const handleSubmit = (values) => {
    console.log(values); // 打印提交的数据

    const startTimeHour = values.startTime.$H;
    const endTimeHour = values.endTime.$H;
    const startTimeMinute = values.startTime.$m;
    const endTimeMinute = values.endTime.$m;

    const formatTime = (hour, minute) => {
      // 将小时和分钟转换为两位数字符串，不足两位前面补零
      const paddedHour = hour.toString().padStart(2, "0");
      const paddedMinute = minute.toString().padStart(2, "0");
      return `${paddedHour}:${paddedMinute}`;
    };

    const formattedStartTime = formatTime(startTimeHour, startTimeMinute);
    const formattedEndTime = formatTime(endTimeHour, endTimeMinute);

    console.log(formattedStartTime); // 输出格式如 "05:30"
    console.log(formattedEndTime); // 输出格式如

    const dateYear = values.date.$y;
    const dateMonth = values.date.$M + 1; // $M 是从 0 开始的月份索引
    const dateDay = values.date.$D;

    const formatDate = (year, month, day) => {
      // 将月份和日期转换为两位数字符串，不足两位前面补零
      const paddedMonth = month.toString().padStart(2, "0");
      const paddedDay = day.toString().padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    };

    const formattedDate = formatDate(dateYear, dateMonth, dateDay);

    console.log(formattedDate); // 输出格式如 "2023-12-21"

    // 现在可以计算时间差了
    let hoursWorked =
      endTimeHour -
      startTimeHour +
      (endTimeMinute - startTimeMinute - values.breakLength) / 60;

    if (hoursWorked < 0) {
      hoursWorked += 24;
    }

    axios
      .post("/api/addRecord", {
        date: formattedDate,
        startTime: formattedStartTime,
        endTime: formattedEndTime,
        restDuration: values.breakLength,
        workTime: hoursWorked,
        user: { id: values.name },
      })
      .then((res) => {
        message.info("上传成功！");
      });

    // 显示消息
    message.info(`您今天工作了${hoursWorked.toFixed(2)}小时。`);
  };

  return (
    <Form form={form} onFinish={handleSubmit}>
      <Form.Item
        name="department"
        label="部门/Department: "
        rules={[{ required: true, message: "请选择部门" }]}
      >
        <Select placeholder="选择部门" onChange={handleDepartmentChange}>
          {departments.map((dept) => (
            <Option key={dept} value={dept}>
              {dept}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="name"
        label="姓名/Name: "
        rules={[{ required: true, message: "请输入姓名" }]}
      >
        <Select placeholder="选择姓名/Name">
          {users.map((user) => (
            <Option key={user.id} value={user.id}>
              {user.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="date"
        label="日期/Date: "
        rules={[{ required: true, message: "请选择日期" }]}
      >
        <DatePicker />
      </Form.Item>

      <Form.Item
        name="startTime"
        label="上班时间/Start Time: "
        rules={[{ required: true, message: "请选择上班时间" }]}
      >
        <TimePicker format="HH:mm" minuteStep={15} />
      </Form.Item>

      <Form.Item
        name="endTime"
        label="下班时间/End Time: "
        rules={[{ required: true, message: "请选择下班时间" }]}
      >
        <TimePicker format="HH:mm" minuteStep={15} />
      </Form.Item>

      <Form.Item
        name="breakLength"
        label="休息时长 (分钟)/Rest Time(Min): "
        initialValue={0}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          提交
        </Button>
      </Form.Item>
    </Form>
  );
}

export default AttendanceForm;
